import { useCallback } from 'react';

import { stripHtmlTags } from '@change-corgi/core/html';
import { useI18n } from '@change-corgi/core/react/i18n';

import { useDecisionMakerResponsePageData } from 'src/app/pages/decisionMakerResponse/details/pageContext';
import { useCurrentUser } from 'src/app/shared/hooks/session';
import type { ShareActionsOptions } from 'src/app/shared/hooks/share';

import type { Channel } from './types';

export function useGetShareText(): ShareActionsOptions<Channel>['getText'] {
	const {
		data: {
			decisionMakerResponse: {
				message,
				petition: { ask },
				decisionMaker,
			},
		},
	} = useDecisionMakerResponsePageData();
	const { translate } = useI18n();
	const user = useCurrentUser();

	return useCallback(
		(channel, type, { url }) => {
			switch (channel) {
				case 'twitter':
					// FIXME should we really use the message for the text?
					return stripHtmlTags(message).substring(0, 200);
				case 'email':
					if (type === 'title')
						return translate('fe.pages.decision_maker_response.email.subject', {
							petitionTitle: ask,
							dmName: decisionMaker.displayName,
						});
					return translate('fe.pages.decision_maker_response.email.body', {
						petitionTitle: ask,
						dmName: decisionMaker.displayName,
						url,
						from: user?.firstName || '',
					});
				default:
					return '';
			}
		},
		[message, decisionMaker, user, ask, translate],
	);
}
